import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sass-two-apps',
  templateUrl: './sass-two-apps.component.html',
  styleUrls: ['./sass-two-apps.component.scss']
})
export class SassTwoAppsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
